import {
    ChangeDetectionStrategy,
    EventEmitter,
    Component,
    Input,
    Output,
    OnDestroy,
    OnInit
} from '@angular/core';
import {Job} from '../../../models/job.model';
import {JobService} from '../../../services/job.service';
import {ApiJobsService} from '../../../services/api-jobs.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {StateService} from '../../../../core/services/state/state.service';
import {EvaluationRequestNext} from '../../../../people/models/evaluation-request-next.model';
import {emailValidator} from '../../../../people/validators/email';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../environments/environment';
import {AlertService} from '../../../../shared/alert/services/alert.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-mobile-jobs-profiler-email',
    templateUrl: './mobile-jobs-profiler-email.component.html',
    styleUrls: ['./mobile-jobs-profiler-email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileJobsProfilerEmailComponent implements OnInit, OnDestroy {
    @Input() profilerEmailData: any;

    @Output() close = new EventEmitter();

    flipValue: any;

    toggle = 1;

    jobProfilerEmailNextForm: UntypedFormGroup;
    requiredBy: string;
    sessionStructure: any = {};
    userData: any = null;
    mailto: string;
    blurred: boolean;
    evaluationRequestNext: EvaluationRequestNext = new EvaluationRequestNext();
    tempUser: any;
    job: Job;

    private subscriptions = new Subscription();

    readonly profilerFormUrl = ''; // environment.profilerFormUrl;

    constructor(private apiJobsService: ApiJobsService,
                private stateService: StateService,
                private fb: UntypedFormBuilder,
                public jobService: JobService,
                public translate: TranslateService,
                public alertService: AlertService) {
    }

    ngOnInit() {
        this.evaluationRequestNext = new EvaluationRequestNext();

        this.tempUser = (this.profilerEmailData && this.profilerEmailData.tempUser) ? this.profilerEmailData.tempUser : null;
        this.job = (this.jobService.jobToDisplay) ? this.jobService.jobToDisplay : null;

        if (this.tempUser && this.tempUser.email) {
            this.evaluationRequestNext.emailTo = this.tempUser.email;
        }

        // Init
        this.initJobProfilerEmailNextForm();
    }

    initJobProfilerEmailNextForm() {
        this.jobProfilerEmailNextForm = this.fb.group({
                emailTo: [this.evaluationRequestNext.emailTo, [Validators.required]],
                // subject : [this.evaluationRequestNext.subject],
                message: [this.evaluationRequestNext.message]
            },
            {
                validator: emailValidator('emailTo')
            });
    }

    toggleFlip(n) {
        this.toggle = n;
    }

    onSubmitEmailNext(model: UntypedFormGroup) {
        this.subscriptions.add(this.apiJobsService.profilerRequestNext([this.jobService.id], [
            this.tempUser.id, model.value.emailTo, model.value.message
        ]).subscribe(
            () => {
                let message = {
                    paragraph: this.translate.instant('people.alert.successRequest.paragraph'),
                    texth1: this.translate.instant('people.alert.successRequest.title'),
                    position: 'top-right',
                    type: 'green'
                };
                this.alertService.setConfig(message);
                this.finishSending();
            }
        ));
    }

    cutNPasteGeneration() {
        let cutPasteTitle = this.translate.instant('people.requestModal.cutnpasteTitle');
        let firstParagraph = this.translate.instant('people.requestModal.fillQuestionnaireToDefinePosition', {
            jobTitle: this.job.jobTitle
        });
        let usernameText = this.translate.instant('people.requestModal.yourUsername', {
            username: this.tempUser.username
        });
        let pwdText = this.translate.instant('people.requestModal.yourPassword', {
            pwd: this.tempUser.tmpPwd
        });
        let questionnaireLink = `${this.profilerFormUrl}/login?lang=${this.translate.currentLang}&username=${this.tempUser.username}&password=${this.tempUser.tmpPwd}`;

        return `<h3><b>${cutPasteTitle}</b></h3>
                <br>
                <p>${firstParagraph}</p>

                <p>${usernameText}<br>${pwdText}</p>

                <p><a href="${questionnaireLink}" target="_blank">${this.translate.instant('people.requestModal.clickToStart')}</a>
                    <br>${questionnaireLink}
                </p>

                <p>${this.translate.instant('people.requestModal.cutPasteNote')}</p>`;
    }

    mailToGeneration() {
        let firstText = this.translate.instant('people.requestModal.fillQuestionnaireToDefinePosition', {
            jobTitle: this.job.jobTitle
        });
        let usernameText = this.translate.instant('people.requestModal.yourUsername', {
            username: this.tempUser.username
        });
        let pwdText = this.translate.instant('people.requestModal.yourPassword', {
            pwd: this.tempUser.tmpPwd
        });
        let questionnaireLink = `${this.profilerFormUrl}/login?lang=${this.translate.currentLang}&username=${this.tempUser.username}&password=${this.tempUser.tmpPwd}`;
        questionnaireLink = encodeURIComponent(questionnaireLink);

        return `${this.translate.instant('people.requestModal.hello')}%0A%0A
            ${firstText}%0A%0A
            ${usernameText}%0A
            ${pwdText}%0A
            ${this.translate.instant('people.requestModal.clickToStart')}
            ${this.translate.instant('people.requestModal.colon')}
            ${questionnaireLink}%0A%0A
            ${this.translate.instant('people.requestModal.cutPasteNote')}`;
    }

    finishSending() {
        this.toggle = 1;
        this.flipValue = '';
        this.close.emit(true);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.close.emit(true);
    }

}
